import { keyframes, Stack } from '@mui/material'
import { OTPInput as InputOtp, OTPInputProps, SlotProps } from 'input-otp'
import ringEffect from 'ui-components/utilities/ringEffect'

const blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const OtpInput = (props: OTPInputProps) => {
  const { children, ...rest } = props
  return (
    <InputOtp
      {...rest}
      render={({ slots }) => (
        <Stack
          direction='row'
          flexWrap='wrap'
          justifyContent='center'
          alignItems='center'
          gap={1}
          sx={{
            '& .Slot': {
              border: (theme) => `solid 1px ${theme.palette.grey[400]}`,
              borderRadius: 2
            }
          }}
        >
          {slots.map((slot, idx) => (
            <Slot
              key={idx}
              {...slot}
            />
          ))}
        </Stack>
      )}
    />
  )
}

function Slot(props: SlotProps) {
  return (
    <Stack
      className='Slot'
      justifyContent='center'
      alignItems='center'
      sx={[
        {
          width: '5rem',
          height: '7rem',
          typography: 'next:h3',
          fontWeight: 500
        },
        (theme) =>
          props.isActive
            ? {
                ...ringEffect({
                  ringColor: theme.palette.primary.main,
                  ringWidth: '3px'
                }),
                borderColor: theme.palette.primary.main
              }
            : {}
      ]}
    >
      {props.char ?? props.placeholderChar}
      {props.hasFakeCaret && (
        <Stack
          fontWeight={300}
          sx={{
            animation: `${blink} 0.8s linear infinite`
          }}
        >
          |
        </Stack>
      )}
    </Stack>
  )
}
